import React from "react";
import Pagetitle from "../elements/Pagetitle";
import TrackVisibility from "react-on-screen";
import Winner from "../elements/Winner";

const winnerData = [
	{
		id: 1,
		title: "1st Place - Hackathon on Explainability",
		organization: "ACPR (Autorité de Contrôle Prudentiel et de Résolution)",
		description:
			"1st place at the Hackathon on the explainability of risk scoring models",
		link: "https://www.linkedin.com/posts/slim-amk_fintech-innovation-techsprint-activity-6817737034778603520-9h3J",
		linkText: "View on LinkedIn",
		icon: "icon-trophy",
	},
	{
		id: 2,
		title: "Best Young Statistician Presentation Award",
		organization: "ENBIS Spring Meeting 2024",
		description:
			"Recognition for outstanding presentation at the European Network for Business and Industrial Statistics conference",
		link: "https://conferences.enbis.org/event/45/page/60-news",
		linkText: "View Award",
		icon: "icon-star",
	},
];

function Awards() {
	return (
		<section id="awards" className="awards-section">
			<div className="container">
				<Pagetitle title="Awards & Recognition" />
				<div className="row fix-spacing">
					{winnerData.map((winner) => (
						<div key={winner.id}>
							<TrackVisibility once>
								<Winner winnerItem={winner} />
							</TrackVisibility>
						</div>
					))}
				</div>
			</div>
		</section>
	);
}

export default Awards;

